import React from "react"
import { ResponsiveSankey } from "@nivo/sankey"
import { ISankeyCustomProp } from "./interface"

const SankeyGraph: React.FC<ISankeyCustomProp> = ({
	links,
	nodes,
	sort = "descending",
	enableLinkGradient = true,
	labelPosition = "outside",
	margin = {},
	valueFormat,
	labelTextColor,
}) => {
	return (
		<ResponsiveSankey
			data={{
				nodes: nodes,
				links: links,
			}}
			colors={(node) => node.nodeColor}
			sort={sort}
			enableLinkGradient={enableLinkGradient}
			labelPosition={labelPosition}
			margin={margin}
			labelPadding={10}
			valueFormat={valueFormat}
			labelTextColor={labelTextColor}
		/>
	)
}

export default SankeyGraph
